import { render } from "./FloorPlanCard.vue?vue&type=template&id=0ddc312a&scoped=true"
import script from "./FloorPlanCard.vue?vue&type=script&lang=js"
export * from "./FloorPlanCard.vue?vue&type=script&lang=js"

import "./FloorPlanCard.vue?vue&type=style&index=0&id=0ddc312a&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ddc312a"]])

export default __exports__